class FloorElementStartPoint {
  store;
  id;
  feId;
  startPoint;


  constructor(store, id, feId, startPoint) {
    this.store = store;
    this.id = id;
    this.feId = feId;

    this.startPoint = startPoint;
  }

  static fromJSON(store, json) {
    let { id, feId, startPoint} = json;
    return new FloorElementStartPoint(store, id, feId, startPoint);
  }
}

export default FloorElementStartPoint;
